import React from 'react';
import './Success.css';

const Success = () => {
    return (
        <div class="container">
        <div class="card">
            <div class="card-body">
                <div class="box">
                    <div class="text text-center"><h1>Thank you!</h1></div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Success;